/* eslint-disable no-param-reassign */

import {RuleBundleModel} from '../../models/api/ruleBundleModel';
import {RuleModel} from '../../models/api/ruleModel';
import {DelayParameter} from '../editors/commons/paramModel';
import {RuleParametersDependencies} from './ruleConditionModel';

export interface RuleListState {
  // Properties.
  hideInactiveGlobal: boolean;
  bundles: ReadonlyArray<RuleBundleModel>;
  globalBundles: ReadonlyArray<RuleBundleModel>;
  integrationErrors: Array<string>;
  dependencies: RuleParametersDependencies;
  shouldDisplayGlobalRule?: (rule: RuleModel) => boolean;
}

export enum RuleListActionTypesEnum {
  UPDATE_BUNDLE = 'updateBundle',
  UPDATE_BUNDLES = 'updateBundles',
  UPDATE_BUNDLES_ORDER = 'updateBundlesOrder',
}
export type RuleListAction = UpdateBundle | UpdateBundles | UpdateBundlesOrder;

type UpdateBundle = {
  type: RuleListActionTypesEnum.UPDATE_BUNDLE;
  bundle: RuleBundleModel;
};

type UpdateBundles = {
  type: RuleListActionTypesEnum.UPDATE_BUNDLES;
  bundles: ReadonlyArray<RuleBundleModel>;
  globalBundles: ReadonlyArray<RuleBundleModel>;
  integrationErrors: Array<string>;
};

type UpdateBundlesOrder = {
  type: RuleListActionTypesEnum.UPDATE_BUNDLES_ORDER;
  bundles?: ReadonlyArray<RuleBundleModel>;
  global?: ReadonlyArray<RuleBundleModel>;
};

export type PartialDelayParameter = Partial<DelayParameter>;

export function toDelayParameter(partialDelayParameter?: PartialDelayParameter): DelayParameter | undefined {
  return partialDelayParameter?.unit && partialDelayParameter?.val
    ? (partialDelayParameter as DelayParameter)
    : undefined;
}
